import { render } from "./CumulativeRiskScore.vue?vue&type=template&id=7c2c1742&scoped=true"
import script from "./CumulativeRiskScore.vue?vue&type=script&lang=js"
export * from "./CumulativeRiskScore.vue?vue&type=script&lang=js"

import "./CumulativeRiskScore.vue?vue&type=style&index=0&id=7c2c1742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c1742"]])

export default __exports__